import type { TOC } from '@ember/component/template-only'
import type SubscriptionTypeController from 'teacher-ui-client/subscription-type/controller'
import { FidgetLoadingIndicatorComponent } from '@blakeelearning/fidget/components/fidget/loading-indicator'
import { NavBar } from 'teacher-ui-client/components/nav-bar'
import { RolloverLockAlert } from 'teacher-ui-client/components/rollover/lock/alert'
import { FooterMain } from 'teacher-ui-client/components/footer-main'
import { StudentCounts } from 'teacher-ui-client/components/page-header/student-counts'
import { t } from 'ember-intl'
import { Tooltip } from 'teacher-ui-client/components/tooltip'
import RouteTemplate from 'ember-route-template'
import { or } from 'ember-truth-helpers'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { SideNavForSubscription } from 'teacher-ui-client/components/side-nav'

interface Signature {
  Args: {
    controller: SubscriptionTypeController
  }
}

export const SubscriptionTypePage: TOC<Signature> = <template>
  <FidgetLoadingIndicatorComponent @show={{@controller.currentlyLoading}} @centered={{true}} />

  <div class="flex min-h-screen flex-col print:block">
    <NavBar class="mb-6 print:hidden" />

    <div class="flex w-full shrink-0 grow print:block">
      <SideNavForSubscription />

      <main class="w-5/6 min-w-64 print:w-full">
        <RolloverLockAlert class="mx-auto my-4 max-w-5xl print:hidden" />
        {{#unless (or @controller.limitedAccess @controller.disableCounts)}}
          <div class="mr-2 flex flex-wrap justify-end whitespace-nowrap lg:mr-20 print:hidden">
            <div class="flex items-center">
              <StudentCounts
                @prefix={{t "pageHeader.subscribedStudentsLabel"}}
                @value={{or @controller.subscribedStudentCount "0"}}
                @tooltip={{t "pageHeader.subscribedStudentsTooltip"}}
                @iconStart="phosphor-users-three-fill"
              />

              <span class="mx-1">/</span>
              <StudentCounts
                data-test-capacity
                @value={{or @controller.subscriptionCapacitySize "0"}}
                @tooltip={{t "pageHeader.allocatedStudentsTooltip"}}
              />
            </div>
            {{#if @controller.isOverCapacity}}
              <span class="ml-2" data-test-over-capacity-icon>
                <Tooltip @text={{@controller.overCapacityTooltipMessage}} />
                <PhosphorIcon @icon="phosphor-warning-fill" class="text-juicy-orange-400 h-5 w-5 cursor-pointer" />
              </span>
            {{/if}}
            {{#if @controller.isSubco}}
              <StudentCounts
                data-test-total-students
                class="ml-6"
                @prefix={{t "pageHeader.totalStudentsLabel"}}
                @value={{@controller.schoolStudentCount}}
                @tooltip={{t "pageHeader.totalStudentsTooltip"}}
                @iconStart="phosphor-building-apartment-fill"
              />
            {{/if}}

          </div>
        {{/unless}}
        <div class="relative mx-2 flex pr-6 pl-2 print:block">
          {{outlet}}
        </div>
      </main>
    </div>

    <FooterMain class="mt-12" />
  </div>
</template>

export default RouteTemplate(SubscriptionTypePage)
